import Vue from "vue";
import VueRouter from "vue-router";
import { RouteName } from "./types";
import { routes } from "./routes";
import storageService from "../services/storageService/storageService";
import { LocalStorageItems } from "@/helpers/constants";
import apiService from "@/services/apiService/apiService";
import store from "@/store";
import { Namespace } from "@/store/types";
import { AlertAction, AlertType } from "@/components/alert/types";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import { LocaleLogin } from "@/plugins/i18n/types";

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.meta?.requiresAuth) {
    try {
      const cachedToken = storageService.getItem<string>(
        LocalStorageItems.Token
      );
      const isTokenValid = cachedToken
        ? await apiService.isLoggedIn(cachedToken)
        : false;
      if (isTokenValid) {
        return next();
      } else {
        await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
          show: true,
          message: i18n.t(LocaleLogin.sessionExpired),
          alertType: AlertType.Info
        });
        return next({ name: RouteName.Login });
      }
    } catch (error) {
      await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
        show: true,
        message: i18n.t(LocaleLogin.sessionExpired),
        alertType: AlertType.Info
      });
      return next({ name: RouteName.Login });
    }
  }

  return next();
});

export default router;
